module.exports = __webpack_public_path__ + "static/media/address11.d065ba68.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/features/themes/assets/andimar/favoriteDestinations/address11.jpg
// module id = 706
// module chunks = 0